import React from 'react';
import SafeIcon from '../../SafeIcon';
import { FiStar } from 'react-icons/fi';

const defaultReviews = [
  { id: 1, name: 'Sarah Jenkins', role: 'Verified Buyer', content: 'Absolutely love this product! It exceeded all my expectations and the quality is outstanding.', rating: 5, avatar_url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=128&q=80' },
  { id: 2, name: 'Michael Chen', role: 'Entrepreneur', content: 'This completely transformed how I run my business. Highly recommended to anyone on the fence.', rating: 5, avatar_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=128&q=80' },
  { id: 3, name: 'Emily Rodriguez', role: 'Designer', content: 'Incredible attention to detail and superb customer service. I will definitely be a returning customer.', rating: 4, avatar_url: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=128&q=80' }
];

const ReviewsWidget = ({ styles = {} }) => {
  const {
    columns = 3,
    showAvatars = true,
    showSummary = true,
    cardBgColor = '#ffffff',
    textColor = '#111827',
    starColor = '#f59e0b',
    borderRadius = 16,
    reviews = defaultReviews
  } = styles;

  const gridColsClass = columns === 1 ? 'grid-cols-1' : columns === 2 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1 md:grid-cols-3';

  const averageRating = reviews.reduce((acc, r) => acc + r.rating, 0) / (reviews.length || 1);

  return (
    <div className="w-full h-full flex flex-col pointer-events-none">
      {showSummary && (
        <div className="flex flex-col items-center justify-center mb-8">
          <div className="flex items-center space-x-1 mb-2">
            {[1, 2, 3, 4, 5].map(star => (
              <SafeIcon 
                key={star} 
                icon={FiStar} 
                className={`w-6 h-6 ${star <= Math.round(averageRating) ? 'fill-current' : 'opacity-30'}`} 
                style={{ color: starColor }}
              />
            ))}
          </div>
          <div className="text-xl font-bold font-sans" style={{ color: textColor }}>
            {averageRating.toFixed(1)} out of 5
          </div>
          <div className="text-sm opacity-70 mt-1 font-sans" style={{ color: textColor }}>
            Based on {reviews.length} reviews
          </div>
        </div>
      )}

      <div className={`grid ${gridColsClass} gap-6 w-full`}>
        {reviews.map((review) => (
          <div 
            key={review.id} 
            className="p-6 shadow-sm border border-black/5"
            style={{ 
              backgroundColor: cardBgColor, 
              borderRadius: `${borderRadius}px`,
              color: textColor 
            }}
          >
            <div className="flex items-center space-x-1 mb-4">
              {[1, 2, 3, 4, 5].map(star => (
                <SafeIcon 
                  key={star} 
                  icon={FiStar} 
                  className={`w-4 h-4 ${star <= review.rating ? 'fill-current' : 'opacity-30'}`} 
                  style={{ color: starColor }}
                />
              ))}
            </div>
            <p className="mb-6 opacity-90 leading-relaxed font-sans text-sm">"{review.content}"</p>
            <div className="flex items-center space-x-3 mt-auto">
              {showAvatars && review.avatar_url && (
                <img src={review.avatar_url} alt={review.name} className="w-10 h-10 rounded-full object-cover" />
              )}
              <div>
                <div className="font-bold text-sm font-sans">{review.name}</div>
                {review.role && <div className="text-xs opacity-70 font-sans">{review.role}</div>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewsWidget;